import { render, staticRenderFns } from "./PageContainer.vue?vue&type=template&id=24c8ce2a&scoped=true&"
import script from "./PageContainer.vue?vue&type=script&lang=ts&"
export * from "./PageContainer.vue?vue&type=script&lang=ts&"
import style0 from "./PageContainer.vue?vue&type=style&index=0&id=24c8ce2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c8ce2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VIcon,VImg,VProgressCircular})
